import { Component, OnInit, Output } from '@angular/core';
import clone from 'just-clone';
import { ReplaySubject } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ServiceItemHistory } from '../../data-services/service-item/history';
import { EditGrid, ResponseStatus } from '../../shared';
import { LoggingService } from '../../shared/services/logging/logging.service';
@Component({
    selector: 'ef-service-item-history',
    templateUrl: './service-item-history.component.html',
    styleUrls: ['./service-item-history.component.scss'],
    standalone: false
})
export class ServiceItemHistoryComponent
    extends EditGrid<ServiceItemHistory>
    implements OnInit
{
    editing: ServiceItemHistory;
    dropdownItemHeight = environment.dropdownItemHeight;
    @Output() public Save = new ReplaySubject<Partial<ServiceItemHistory>>(1);
    constructor(private log: LoggingService) {
        super();
    }
    ngOnInit(): void {}
    onRowEditInit(item: ServiceItemHistory) {
        this.cloned[item.id] = clone(item);
        this.editing = clone(item);
        this.log.verbose({
            type: 'ProjectBudgetComponent:onRowEditInit',
            item,
            cloned: this.cloned,
            editing: this.editing
        });
        // this.Select.next(item);
        // this.selected = [];
    }
    onRowEditSave(item: ServiceItemHistory) {
        item.Status.StatusCode = ResponseStatus.Loading;
        item.Status.Message = 'Saving';
        this.Save.next(item);

        delete this.cloned[item.id];
        delete this.editing;
        // this.selected = [];
    }
    onRowEditCancel(item: ServiceItemHistory) {
        const index = this.items.findIndex(x => x.id === item.id);
        if (index >= 0) {
            this.items.splice(index, 1, this.cloned[item.id]);
        }
        this.items = [...this.items];
        // this.selected = [];

        delete this.cloned[item.id];
        delete this.editing;
    }
}
